import { api } from '../Configs/AxiosConfigs'
import { defineCancelApiObject } from '../Configs/AxiosUtils'

export const UsersApis = {
  getBearerToken: function () {
    // console.log(":getBearerToken", `Bearer:${localStorage.getItem("Authorization")}`)
    return {
      "Authorization": `Bearer:${localStorage.getItem("Authorization")}`
    }
  },
  getAccessToken: function () {
    // console.log(":getAccessToken", JSON.parse(localStorage.getItem("user")))
    return {
      "user": JSON.parse(localStorage.getItem("user"))
    }
  },
  userBuddyRequestReceivedBuddyLive: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/buddy/request/receive/buddylive`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  userBuddyRequestReceived: async function (userObj, cancel = false) {
    const response = await api.request({
      // url: `/v1/user/buddy/request/receive`,
      url: `/v1/buddy/request/receive/paginated`,
      method: 'POST',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userBuddyRequestApproved: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/buddy/request/approve`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userBuddyRequestSend: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/buddy/request/send`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userBuddyRequestDenied: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/buddy/request/deny`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userBuddyRequestUnBuddy: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/buddy/request/unbuddy`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userBuddyRequestBlocked: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/buddy/request/block`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userGetBuddy: async function (userObj, cancel = false) {
    const response = await api.request({
      url: `/v1/buddy`,
      method: 'GET',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userGetNotification: async function (userObj, cancel = false) {
    const response = await api.request({
      // url: `/v1/notification`,
      url: `/v1/notification/user`,
      method: 'POST',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  getUserProfileOfOtherUser: async function (userObj, cancel = false) {
    // let accesToken = {
    //   fre8ProAccessToken: userObj?.fre8ProAccessToken,
    // }
    const response = await api.request({
      // url: `/v1/profile/${userObj?.userId}`,
      // url: `/v1/profile/imagev2/self`,
      url: `/v1/profile/imagev2/other`,
      method: 'POST',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  sendMessage: async function (userObj, cancel = false) {

    const response = await api.request({
      url: `/v1/buddy/chatmessage/send`,
      method: 'PUT',
      headers: { "Authorization": `Bearer:${localStorage.getItem("Authorization")}` },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

}
// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(UsersApis)
